import { flow, types as t, destroy } from 'mobx-state-tree';

import { transformApplication } from 'helpers';

import { Application } from 'models/applications';
import { withEnv } from 'models/withEnv';

export const ApplicationStore = t
  .model('ApplicationStore', {
    items: t.map(Application),
  })
  .views(withEnv)
  .views((self) => ({
    get list() {
      return Array.from(self.items.values());
    },
  }))
  .actions((self) => ({
    load: flow(function* (id) {
      const local = self.items.get(id);
      if (local) {
        local.load();
        return true;
      } else {
        const res = yield self.env.api.applications.load(id);
        if (res.error) return false;
        self.addOrUpdate({ ...res.data, loaded: true }, res.data.job);
        return true;
      }
    }),
    grantFollowerAccess(applicationId, users) {
      const application = self.items.get(applicationId);
      users.forEach((user) => {
        user.followCandidate(applicationId);
        if (application) {
          application.job.addToAppFollowCountForUser(user, 1);
        }
      });
    },
    hire(applicationId, user) {
      const application = self.items.get(applicationId);
      if (application) {
        application.isHired = true;
        application.status = 'hired';
        application.hiredByUser = user.id;
      }
    },
    unHire(applicationId) {
      const application = self.items.get(applicationId);
      if (application) {
        application.isHired = false;
        application.status = 'active';
        application.hiredByUser = null;
      }
    },
    retract(applicationId) {
      const application = self.items.get(applicationId);
      if (application) {
        application.isRetracted = true;
        application.status = 'retracted';
      }
    },
    unRetract(applicationId) {
      const application = self.items.get(applicationId);
      if (application) {
        application.isRetracted = false;
        application.status = 'active';
      }
    },
    addOrUpdate(application, job) {
      let a = transformApplication(application);
      a.job = job;
      const curr = self.items.get(a.id);

      if (!curr) {
        self.items.put(a);
      } else {
        self.items.put({ ...curr, ...a });
      }
      return self.items.get(a.id);
    },
    delete(applicationId) {
      const application = self.items.get(applicationId);
      if (application) {
        const job = application.job;
        job.removeApplication(applicationId);
        job.jobStages.forEach((jobStage) => {
          jobStage.removeApplication(applicationId);
        });
        if (job.listView) {
          job.loadJobApplicationsCount();
          if (job.listView.selected.has(applicationId)) {
            job.listView.toggleSelect(application);
          }
        }
        destroy(application);
      }
    },
  }));
